import React from 'react';
import { CardProps } from 'components/Card';
import { useBreakpoint } from 'hooks';
import LayoutCardDesktop from './LayoutCardDesktop';
import LayoutCardMobile from './LayoutCardMobile';

export type LayoutCardCustomProps = {
  search?: {
    searchValue: string;
    onSearchValueChange: (value: string) => void;
  };
  titleLink?:
    | {
        title: React.ReactNode;
        linkPath: string;
      }
    | false
    | null;
  titleExtra?: React.ReactNode;
  titleExtraPosition?: 'left' | 'right';
  hideViewAll?: boolean;
  actions?: React.ReactNode[];
};

const LayoutCard: React.FC<CardProps & LayoutCardCustomProps> = ({
  hideViewAll,
  ...rest
}) => {
  const { md } = useBreakpoint();

  return !md ? (
    <LayoutCardMobile hideViewAll={hideViewAll} {...rest} />
  ) : (
    <LayoutCardDesktop {...rest} />
  );
};

export default LayoutCard;
